import BackgroundModality from "@images/mainLabel/background-modality.svg";
import BackgroundPhase from "@images/mainLabel/background-phase.svg";
import BackgroundTooltipModality from "@images/mainLabel/background-tooltip-modality.svg";
import BackgroundTooltipPhase from "@images/mainLabel/background-tooltip-phase.svg";

export const MODALITY_ENTITY = "E031";
export const TARGET_ENTITY = "E020";
export const DRUG_NAME_ENTITY = "E010";
export const PHASE_ENTITY = "E052";
export const DISEASE_ENTITY = "E040";
export const ENDPOINTS_ENTITY = "E060";
export const DESIGN_ENTITY = "E051";
export const ROA_ENTITY = "E032";
export const DEAL_TYPE_ENTITY = "E060";

// press label
export const PRESS_LABEL_INFO_LIST = [
  {
    id: 3,
    value: "Modality",
    code: "E031",
    border: "1px solid var(--Color-Label-Border-Modality, #AD5BEC)",
    background: " var(--Color-Label-Bg-Modality, #D6ADF5)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Modality, #8219D2)",
  },
  {
    id: 4,
    value: "ROA",
    code: "E032",
    border: "1px solid var(--Color-Label-Border-Modality, #AD5BEC)",
    background: `url(${BackgroundModality}) var(--Color-Label-Bg-Modality, #D6ADF5)`,
    tooltipBackground: `url(${BackgroundTooltipModality}) var(--Color-Label-Bg-Inverse-Modality, #8219D2)`,
  },
  {
    id: 2,
    value: "Target",
    code: "E020",
    border: "1px solid var(--Color-Label-Border-Target, #FFB647)",
    background: "var(--Color-Label-Bg-Target, #FFDAA3)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Target, #EB8D00)",
  },
  {
    id: 1,
    value: "Drug name",
    code: "E010",
    border: "1px solid var(--Color-Label-Border-Medicine, #4791FF)",
    background: "var(--Color-Label-Bg-Medicine, #A3C8FF)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Medicine, #005EEB)",
  },
  {
    id: 6,
    value: "Phase",
    code: "E052",
    border: "1px solid var(--Color-Label-Border-Phase, #EBDF00)",
    background: "var(--Color-Label-Bg-Phase, #FFF875)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Phase, #EBDF00)",
  },
  {
    id: 7,
    value: "Design/Status",
    code: "E051",
    border: "1px solid var(--Color-Label-Border-Phase, #EBDF00)",
    background: `url(${BackgroundPhase}) var(--Color-Label-Bg-Phase, #FFF875)`,
    tooltipBackground: `url(${BackgroundTooltipPhase}) var(--Color-Label-Bg-Inverse-Phase, #EBDF00)`,
  },
  {
    id: 5,
    value: "Disease",
    code: "E040",
    border: "1px solid var(--Color-Label-Border-Disease, #F353A1)",
    background: "var(--Color-Label-Bg-Disease, #FCD4E7)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Disease, #DB0F72)",
  },
  {
    id: 8,
    value: "Endpoints",
    code: "E060",
    border: "1px solid var(--Color-Label-Border-Endpoint, #42CAD7)",
    background: "var(--Color-Label-Bg-Endpoint, #B3EAEF)",
    tooltipBackground: "var(--Color-Label-Bg-Inverse-Endpoint, #29B5C2)",
  },
] as const;

// 검색하는 경우에 변경되어야 하는 라벨 정보
export const SEARCH_PRESS_LABEL_INFO_LIST = [
  {
    id: 3,
    value: "Modality",
    code: "E031",
    border: "1px solid #DFC2F6",
    background: " #F1E4FB",
    tooltipBackground: "none",
  },
  {
    id: 4,
    value: "ROA",
    code: "E032",
    border: "1px solid #DFC2F6",
    background: `url(${BackgroundModality}) #F1E4FB`,
    tooltipBackground: "none",
  },
  {
    id: 2,
    value: "Target",
    code: "E020",
    border: "1px solid #FDDCB2",
    background: "#FEF2E1",
    tooltipBackground: "none",
  },
  {
    id: 1,
    value: "Drug name",
    code: "E010",
    border: "1px solid #BBEAEF",
    background: "#EEF7F9",
    tooltipBackground: "none",
  },
  {
    id: 6,
    value: "Phase",
    code: "E052",
    border: "1px solid #F6F19D",
    background: "#FAF9E0",
    tooltipBackground: "none",
  },
  {
    id: 7,
    value: "Design/Status",
    code: "E051",
    border: "1px solid #F6F19D",
    background: `url(${BackgroundPhase}) #FAF9E0`,
    tooltipBackground: "none",
  },
  {
    id: 5,
    value: "Disease",
    code: "E040",
    border: "1px solid #F9D0E5",
    background: "#F9F3F8",
    tooltipBackground: "none",
  },
  {
    id: 8,
    value: "Endpoints",
    code: "E060",
    border: "1px solid #BBEAEF",
    background: "#EEF7F9",
    tooltipBackground: "none",
  },
] as const;
